import React from 'react';
import s from '../main-header.scss';
import WixDevelopersLogoSvg from '../../../assets/MainHeader/WixDevelopersLogo.svg?url';
import { links } from '../constants';
import { Image } from 'wix-style-react';
export const WixDevelopersLogo = () => {
    return (React.createElement("a", { "data-hook": "wix-developers-logo", className: s.logoWrapperNewStyle, href: links.logo },
        React.createElement(Image, { fit: "contain", height: "36px", src: WixDevelopersLogoSvg, width: "192px", transparent: true })));
};
//# sourceMappingURL=WixDevelopersLogo.js.map